export default __webpack_public_path__ + "static/media/CORDIA.b1ddf3d9.ttf";